import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { PendingRequestsService } from '@app/core/progress/pending-requests.service';
import { SILENT_REQUEST } from '@shared/utils/http-context.util';

export const pendingRequestsInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SILENT_REQUEST)) {
    return next(request);
  }

  const pendingRequestsService = inject(PendingRequestsService);
  pendingRequestsService.start();

  return next(request).pipe(finalize(() => pendingRequestsService.finish()));
};
